import { crudMutations, crudActions, attachmentActions, shipmentActions } from './modules/action-helpers'

const basePath = 'api/reception'

export default {
  namespaced: true,
  basePath: basePath,
  state: {
    items: [],
    count: 0,
    currentPage: 1,
    typeId: 2, // Assuming '2' is the type ID for receptions
    currentItem: null,
    listQuery: null
  },
  mutations: {
    ...crudMutations()
  },
  actions: {
    ...crudActions({ basePath: basePath }),
    ...attachmentActions({ basePath: basePath }),
    ...shipmentActions({ basePath: basePath })
  },
  getters: {
    objects (state) { return state.items }
  }
}



// WEBPACK FOOTER //
// ./src/store/receptions.js